import styled from 'styled-components'
import { VStack } from '@revolut-internal/ui-kit'

import { chatMessagesListWidth } from './ChatMessagesList.constants'

export const ChatMessagesListWrapper = styled(VStack)`
  width: ${chatMessagesListWidth}px;
  height: 100%;

  & > span:first-child {
    margin-top: auto;
  }
`
